var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 36,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.79,
    r: 17.5,
    fill: "#00333e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "x_svg__b",
    width: 15,
    height: 16,
    x: 10,
    y: 10,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x_svg__a)",
    d: "M10 10.29h15v15H10z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#x_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2C6BA",
    d: "M10.682 9.608h15.682V25.29H10.682z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "x_svg__a",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x_svg__c",
    transform: "scale(.00195)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiB0ZXh0LXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiBpbWFnZS1yZW5kZXJpbmc9Im9wdGltaXplUXVhbGl0eSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHZpZXdCb3g9IjAgMCA1MTIgNDYyLjc5OSI+PHBhdGggZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNNDAzLjIyOSAwaDc4LjUwNkwzMTAuMjE5IDE5Ni4wNCA1MTIgNDYyLjc5OUgzNTQuMDAyTDIzMC4yNjEgMzAxLjAwNyA4OC42NjkgNDYyLjc5OWgtNzguNTZsMTgzLjQ1NS0yMDkuNjgzTDAgMGgxNjEuOTk5bDExMS44NTYgMTQ3Ljg4TDQwMy4yMjkgMHptLTI3LjU1NiA0MTUuODA1aDQzLjUwNUwxMzguMzYzIDQ0LjUyN2gtNDYuNjhsMjgzLjk5IDM3MS4yNzh6Ii8+PC9zdmc+",
    id: "x_svg__c",
    width: 512,
    height: 512
  }))));
};
export default SvgX;